import { axios, Response } from '../index'

type Body = {
  checklistItemId: string
  title: string
  responsibleForTheDemandId?: string
}

const addChecklistItem = (
  companyId: string,
  personaType: string,
  personaId: string,
  checklistId: string,
  taskId: string,
  body: Body
): Response<null> => {
  return axios.post(
    `/v1/tasks/${taskId}/checklists/${checklistId}/checklist-items`,
    body,
    {
      headers: {
        'X-CompanyID': companyId,
        'X-PersonaType': personaType,
        'X-PersonaID': personaId
      }
    }
  )
}

export default addChecklistItem
